export default {"src":"/_next/static/media/service.327382c2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};